module.exports = __webpack_public_path__ + "static/img/IMG_20170720_103232.f8445713.jpg";